import { useState, useEffect, memo, useRef } from 'react'
import { createClient } from '@supabase/supabase-js'
import CoorayAppBar, { NavigationButtonType } from '../../shared/components/CoorayAppBar';
import { useParams, useSearchParams } from 'react-router-dom';
import CurationRepository from '../../repository/CurationRepository';
import PlaceRepository from '../../repository/PlaceRepository';
import CurationListFilterBar from '../../shared/components/CurationListFilterBar';
import CurationListItem from '../../shared/components/curationitem/CurationListItem';
import FilterModal from '../../shared/components/filtermodal/FilterModal';
import { useNavigate } from 'react-router-dom';
import SortModal from '../../shared/components/sortmodal/SortModal';
import CoorayFooter from '../../shared/components/footer/CoorayFooter';
import { AnalyticsEvent } from '../../shared/analytics/AnalyticsEvent';
import { Helmet } from 'react-helmet';
import { usePlaceDetailsContext } from '../placedetails/PlaceDetailsContext';
import { useCurationContext } from './CurationContext';
import { useCurationPlacesContext } from './CurationPlacesContext';
import { useCurationScrollStateContext } from './CurationScrollStateContext';
import { getPlaces, getUserLocation } from './CurationListUtils';
import { useCurationMapContentContext, useCurationMapContext, useCurationMapHoverContext } from './CurationMapContext';
import PlaceSuggestionItem from '../../shared/components/curationitem/PlaceSuggestionItem';
import SearchModal from '../../shared/components/searchmodal/SearchModal';
import CollectionWelcomeModal from '../../shared/components/collectionwelcomemodal/CollectionWelcomeModal';
import GeneratedInvitationLinkModal from '../../shared/components/invitationlinkmodal/GeneratedInvitationLinkModal';
import { sendAction, sendPageView } from '../../shared/utils/AnalyticsUtils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useGoogleLogin } from '@react-oauth/google';
import ZipmapRepository from '../../repository/ZipmapRepository';
import { createSlug } from '../../shared/utils/URLUtils';
import { RouteMap } from './RouteMap';
import ZipmapRouteRepository from '../../repository/ZipmapRouteRepository';
import { applyTheme } from '../../shared/utils/ThemeUtils';

const supabase = createClient('https://twblyxzvdbhlhxxurpno.supabase.co', 'eeyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR3Ymx5eHp2ZGJobGh4eHVycG5vIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAzNDMzNTMsImV4cCI6MjA3NTkxOTM1M30.cOz8DeHN7L00i3VN2wF5NXs2quw95Eaz3-8IQs4ltgw')

function filtersToFilterOptionsMap(filters) {
  const filterOptionMap = {}
  filters
  .flatMap(
    (filter) => filter.filterOptions
    .map(
      (filterOption) => {
        filterOption.filter = {
          id: filter.id,
          label: filter.label
        }
        return filterOption
      }
    )
  )
  .forEach((filterOption) => {
    filterOptionMap[filterOption.id] = filterOption
  })
  return filterOptionMap
}

export default function RoutePage({analytics, forceList = false}) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const navigate = useNavigate()
  const topRef = useRef()
  const mainListRef = useRef()
  const desktopIndicatorRef = useRef()
  const titleRef = useRef()
  const mapRef = useRef()
  const mapButtonRef = useRef()
  const searchButtonRef = useRef()
  const descriptionRef = useRef(null);
  const {_, setPlaceDetails} = usePlaceDetailsContext()
  const {placesData, setPlacesData, resetPlacesData} = useCurationPlacesContext()
  const {curationMapPopup, setCurationMapPopup, resetCurationMapPopup} = useCurationMapContentContext()
  const [currentPage, setCurrentPage] = useState(0)
  const {curationScrollState, setCurationScrollState, resetCurationScrollState} = useCurationScrollStateContext()
  const [isShowingList, setIsShowingList] = useState(curationScrollState.isShowingList)
  const [appBarDropdownItems, setAppBarDropdownItems] = useState([])
  const [isTitleVisible, setIsTitleVisible] = useState(true)
  const {curationMapConfig, setCurationMapConfig, resetCurationMapConfig} = useCurationMapContext()
  const {curationHoverId, setCurationHoverId} = useCurationMapHoverContext()
  const {curationData, setCurationData} = useCurationContext()
  const [isListLoading, setIsListLoading] = useState(false)
  const [fullScreenLoadingText, setFullScreenLoadingText] = useState(null)
  const [isDesktopView, setIsDesktopView] = useState(false)
  const [isWebsitePaused, setIsWebsitePaused] = useState(false)
  const [isWebsitePreview, setIsWebsitePreview] = useState(false)
  const [isLongDescriptionExpanded, setIsLongDescriptionExpanded] = useState(false)

  const [isFilterBottomSheetOpen, setIsFilterBottomSheetOpen] = useState(false)
  const [isSortBottomSheetOpen, setIsSortBottomSheetOpen] = useState(false)
  const [isSearchBottomSheetOpen, setIsSearchBottomSheetOpen] = useState(false)
  const [generatedInvitationTitle, setGeneratedInvitationTitle] = useState(null)
  const [generatedInvitationLink, setGeneratedInvitationLink] = useState(null)
  const [toastMessage, setToastMessage] = useState(null)
  const [showExpandButton, setShowExpandButton] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams()
  const { curationId, routeId }= useParams()

  async function getRouteDetails(mapSlug, routeSlug) {
    setIsListLoading(true)
    const zipmapRouteRepository = new ZipmapRouteRepository()
    try {
      const zipmapResponse = await zipmapRouteRepository.getRouteDetails(mapSlug, routeSlug)
      console.log(zipmapResponse)
      const currentIsDesktopView = desktopIndicatorRef.current == null || desktopIndicatorRef.current == undefined || getComputedStyle(desktopIndicatorRef.current).display == "none"

      setCurationData({
        curation: {
          id: zipmapResponse.map.id,
          title: zipmapResponse.map.name,
          displayName: zipmapResponse.map.displayName,
          description: zipmapResponse.map.description,
          customLogo: {
            light: zipmapResponse.map.logo,
            dark: zipmapResponse.map.darkLogo
          },
          coverPhoto: zipmapResponse.map.coverPhoto,
          emoji: zipmapResponse.map.defaultMarker,
          isSortAllowed: zipmapResponse.map.isSortAllowed,
          defaultView: zipmapResponse.map.defaultView
        },
        route: {
          id: zipmapResponse.route.id,
          name: zipmapResponse.route.name,
          description: zipmapResponse.route.description,
          coverPhoto: zipmapResponse.route.photo ?? zipmapResponse.map.coverPhoto,
        },
        filters: [],
      })

      setPlacesData(
        {
          ...placesData,
          places: zipmapResponse.places.map((place) => {
            return {
              ...place,
              title: place.name,
              distance: zipmapResponse.placeIdToDistance ? zipmapResponse.placeIdToDistance[place.id] : null
            }
          }),
          routePoints: zipmapResponse.route.routePoints,
          totalPlaceCount: zipmapResponse.places.length,
          isPlaceListSneakPeek: false,
        }
      )

      sendPageView(analytics, AnalyticsEvent.CURATION_VIEW, {
        collectionId: zipmapResponse.map.id
      })

      if (zipmapResponse.map.primaryColor) {
        applyTheme(zipmapResponse.map.primaryColor);
      }
    } catch (error) {
      console.log(`error ${JSON.stringify(error.response.data)}`)
      if (error.response.data.status == "UNDER_CONSTRUCTION") {
        setIsWebsitePaused(true)
      }
    } finally {
      setIsListLoading(false)
    }
  }

  useEffect(() => {
    if (toastMessage) {
        setTimeout(() => {
            setToastMessage(null)
        }, 3000)
    }
  }, [toastMessage])

  useEffect(() => {
    if (descriptionRef.current) {
      // Check if content height exceeds 200px
      setShowExpandButton(descriptionRef.current.scrollHeight > 100);
    }
  }, [curationData.route?.description]);

  useEffect(() => {

    Promise.all([
      getRouteDetails(curationId, routeId)
    ])
    mainListRef.current.scrollTop = curationScrollState.scrollPosition
  }, [curationId, routeId])

  useEffect(() => {
    const currentIsDesktopView = mapButtonRef.current == null || mapButtonRef.current == undefined || getComputedStyle(mapButtonRef.current).display == "none"
    setIsDesktopView(currentIsDesktopView)
    if (currentIsDesktopView) {
      setIsShowingList(true)
    }
  }, [mapButtonRef.current, curationData])

  const handleScroll = () => {
    const currentScrollPos = mainListRef.current.scrollTop
    setIsTitleVisible(currentScrollPos < 64)
  }

  useEffect( () => {
      mainListRef.current.addEventListener('scroll', handleScroll);
      const handleResize = () => {
        const currentIsDesktopView = mapButtonRef.current == null || mapButtonRef.current == undefined || getComputedStyle(mapButtonRef.current).display == "none"
        console.log(`screen resize ${currentIsDesktopView}`)
        setIsDesktopView(currentIsDesktopView)
        if (currentIsDesktopView) {
          setIsShowingList(true)
        }
      }
      window.addEventListener("resize", handleResize, false);

  })

  async function generateInvitationLink(curationId) {
    if (!curationData.curation.isPrivate && curationData.curation.url) {
      setGeneratedInvitationLink(curationData.curation.url)
      setGeneratedInvitationTitle(curationData.curation.title)
    } else {
      setFullScreenLoadingText("Generating invitation link ...")
      const curationRepository = new CurationRepository()
      const response = await curationRepository.generateInvitationLink(curationId)
      console.log(JSON.stringify(response))
      setGeneratedInvitationLink(response.invitationLink)
      setGeneratedInvitationTitle(response.invitationTitle)
      setFullScreenLoadingText(null)
    }
  }

  function handleItemClick(itemId, item) {
    setCurationScrollState({
      scrollPosition: mainListRef.current.scrollTop,
      isShowingList: isShowingList,
    })
    const selectedFilterOptionIds = item.filterOptionIds
    console.log(`selectedFilterOptionIds ${JSON.stringify(selectedFilterOptionIds)}`)
    // curationData.filters.filter((item) => item.filterOptions.map((option) => option.id).includes())
    const placeRelevantOptions = []
    const filtersWithRelevantOptions = curationData.filters.map((filter) => {
      const filteredOptions = filter.filterOptions.filter((option) => selectedFilterOptionIds.includes(option.id))
      placeRelevantOptions.push(...filteredOptions)
      return {
        ...filter, filterOptions: filteredOptions.map((option) => option.id)
      }
    }).filter((filter) => filter.filterOptions.length > 0)

    setPlaceDetails(
      {
        ...item, filters: filtersWithRelevantOptions, filterOptions: placeRelevantOptions, isCurrentUserAllowedToViewComments: !placesData.isPlaceListSneakPeek
      }
    )

    sendAction(analytics, AnalyticsEvent.CURATION_PLACE_DETAILS_CLICK, AnalyticsEvent.CURATION_VIEW, {
      collectionId: curationData.curation.id,
      placeId: itemId
    })

    console.log(`place details ${JSON.stringify(item)}`)
    const slug = createSlug(item.title, itemId)
    // console.log(`map button ref ${getComputedStyle(mapButtonRef.current).display}`)
    navigate(`/${curationId}/${slug}`)
  }

  function handlePopupItemClick(itemId, item) {
    sendAction(analytics, AnalyticsEvent.MAP_PLACE_ROW_CLICK, AnalyticsEvent.CURATION_VIEW, {
      collectionId: curationData.curation.id,
      placeId: itemId
    })
    handleItemClick(itemId, item)
  }

  function handlePopupItemNavigateClick(itemId) {
    sendAction(analytics, AnalyticsEvent.MAP_MARKER_GOOGLE_NAVIGATE_CLICK, AnalyticsEvent.CURATION_VIEW, {
      collectionId: curationData.curation.id,
      placeId: itemId
    })
  }

  async function getPlacesAndSetState(selectedFilters, sortType, coordinates, distance, visits) {
    console.log(selectedFilters)
    setIsListLoading(true)
    const filterOptionMap = filtersToFilterOptionsMap(curationData.filters)
    const placesResponse = await getPlaces(supabase, curationData.curation.id, filterOptionMap, selectedFilters, sortType, coordinates, distance, visits)
    const placeList = placesResponse.places.map((place) => {
      return {
        ...place,
        exploreOption: placesResponse.googlePlaceIdToExploreParameters[place.googlePlace.placeId]
      }
    })
    setPlacesData(
      {
        places: placeList,
        selectedSortType: sortType,
        selectedFilterOptions: selectedFilters,
        selectedFilterDistance: distance,
        selectedVisitOptions: visits,
        selectedSearchInput: placesData.selectedSearchInput,
        totalPlaceCount: placesResponse.totalPlaceCount,
        isPlaceListSneakPeek: placesResponse.isPlaceListSneakPeek
      }
    )
    setIsListLoading(false)
  }

  function onFilterButtonClick() {
    sendAction(analytics, AnalyticsEvent.FILTER_BUTTON_CLICK, AnalyticsEvent.CURATION_VIEW, {
      collectionId: curationData.curation.id
    })
    setIsFilterBottomSheetOpen(true)
  }

  function onSortButtonClick() {
    sendAction(analytics, AnalyticsEvent.SORT_BUTTON_CLICK, AnalyticsEvent.CURATION_VIEW, {
      collectionId: curationData.curation.id
    })
    // document.getElementById(`sort-modal`).showModal()
    setIsSortBottomSheetOpen(true)
  }

  function onApplySearchClick(input) {
    console.log(`on apply search click ${input}`)
    setIsSearchBottomSheetOpen(false)
    setPlacesData({
      ...placesData, 
      selectedSearchInput: input
    })
    setSearchParams(params => {
      if (input == null || input.length == 0) {
        params.delete("searchInput")
      } else {
        params.set("searchInput", input);
      }
      return params;
    })
  }

  function onBackPressed() {
    navigate(`/${curationId}/route/${routeId}`, { replace: true })
  }

  function onToggleToMapClick() {
    navigate(`/${curationId}/route/${routeId}/map`)
  }

  function onToggleToListClick() {
    window.history.back()
  }

  function onViewAllClick() {
    resetPlacesData()
    resetCurationMapConfig()
    resetCurationScrollState()
    resetCurationMapPopup()
    navigate(`/${curationId}/list`)
  }

  const shareContent = async (title, url) => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Roambear",
          text: title,
          url: url,
        });
      } catch (error) {
        console.error("Error sharing:", error);
      }
    } else {
      alert("Sharing not supported on this device.");
    }
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      console.log("Copied to clipboard:", text);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  Array.prototype.filterPlacesByName = function (searchInput) {
    if (!searchInput) return this; // Return all places if search input is empty
  
    const lowerCasedInput = searchInput.toLowerCase();
  
    return this.filter(place => 
      place.title && place.title.toLowerCase().includes(lowerCasedInput)
    );
  }

  return (
    <div className='h-screen w-screen bg-base-100'>
      <Helmet><title>{isWebsitePaused ? "Website under construction" : (curationData.route && curationData.route.name ? curationData.route.name : "Loading ...") }</title></Helmet>
      <div className={`flex flex-col h-screen fixed w-screen top-0`}>
        <div ref={topRef} className={`fixed md:relative ease-out ease-in duration-300 z-30 w-full md:block md:top-0 ${(!isShowingList && !isDesktopView) ? "bg-base-100" : ""}`}>
          {isWebsitePreview && <div className='w-full text-xs text-center bg-warning text-warning-content p-2'>This map is in preview mode (not live), only editors can see it.</div>}
          <CoorayAppBar 
            customLogo={curationData.curation.customLogo}
            shouldHideTitleInSmall={isTitleVisible}
            shouldHideTitleInBig={isTitleVisible}
            title={curationData.route && curationData.route.name ? curationData.route.name : "Loading ..."}
            navigationType={isWebsitePaused ? NavigationButtonType.Roambear : NavigationButtonType.CustomLogo}
            rightDropdownItems={appBarDropdownItems}
            onBackPressed={onBackPressed}
            endItems={[]}
          />
        </div>
        <div className='grid grid-cols-2 flex-1 overflow-y-hidden relative'>
        <div ref={mainListRef} className={`col-span-2 bg-base-100 md:col-span-1 w-full max-h-full overflow-y-scroll overscroll-contain order-last z-10 pb-20 md:pb-16 md:pt-0 ${ isShowingList || isDesktopView ? "" : "hidden" } md:order-1 absolute md:relative min-h-full`}>
        {
                curationData.route && curationData.route.coverPhoto && <div className='md:p-4'>
                <LazyLoadImage 
                className='h-72 md:h-56 w-full object-cover md:rounded-md'
                src={curationData.route.coverPhoto}
                />
                </div>
              }
              {
                curationData.route && !curationData.route.coverPhoto && <div className='w-full pt-16 md:pt-0'></div>
              }
              {
                curationData.curation && <div className="max-w-full text-base-content text-xs md:text-sm px-4 flex flex-row items-center pt-4">
                  { placesData.totalPlaceCount > 0 && <span>{placesData.totalPlaceCount} place{ placesData.totalPlaceCount > 1? "s": "" }</span>}
                
                 </div>
              }
              {
                  curationData.route && curationData.route.name && <div className='pt-2 px-4 font-bold text-2xl font-titan' ref={titleRef} dangerouslySetInnerHTML={{ __html: curationData.route.name }}>
                  </div>
              }
              {
                curationData.route && curationData.route.description && <div className='w-full max-w-full relative' ref={descriptionRef}>
                <div className={`max-w-full text-base-content text-sm md:text-base px-4 pt-2 ${isLongDescriptionExpanded ? "pb-16" : "line-clamp-6"}`} dangerouslySetInnerHTML={{ __html: curationData.route.description }}></div>
                {
                    showExpandButton && <div className='absolute bottom-0 right-0 text-xs text-base-content w-full text-center bg-gradient-to-t from-base-100 to-transparent py-4'>
                    <button className="btn btn-neutral btn-xs btn-soft normal-case" onClick={() => { setIsLongDescriptionExpanded(!isLongDescriptionExpanded) }}>{ isLongDescriptionExpanded ? "Show less" : "Show more" }</button>
                  </div>
                }
                </div>
              }
              {
                <div className='flex flex-row'>
                {
                  <div className='w-4'></div>
                }
                {
                  curationData.curation.url && <div className="avatar-group py-2">
                  <div className="avatar placeholder cursor-pointer" onClick={() => {
                    generateInvitationLink(curationId)
                  }}>
                        <div className="w-12 bg-secondary text-secondary-content p-4">
                        <svg className='w-6 h-6' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className='stroke-secondary-content' d="M12.7917 15.7991L14.2223 14.3676C16.5926 11.9959 16.5926 8.15054 14.2223 5.7788C11.8521 3.40707 8.0091 3.40707 5.63885 5.7788L2.77769 8.64174C0.407436 11.0135 0.407436 14.8588 2.77769 17.2306C3.87688 18.3304 5.29279 18.9202 6.73165 19" stroke-width="1.5" stroke-linecap="round"/>
                        <path className='stroke-secondary-content' d="M11.2083 8.20092L9.77769 9.63239C7.40744 12.0041 7.40744 15.8495 9.77769 18.2212C12.1479 20.5929 15.9909 20.5929 18.3612 18.2212L21.2223 15.3583C23.5926 12.9865 23.5926 9.14118 21.2223 6.76945C20.1231 5.66957 18.7072 5.07976 17.2683 5" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                        </div>
                      </div>
                      </div>
                }
                </div>
              }
              {
                <div className='h-4'></div>
              }
              {/* {
                  curationData.curation.title && <div className={`sticky top-16 md:top-0 z-20 relative`}>
                    <CurationListFilterBar 
                    activeFilterSize={placesData.selectedFilterOptions.length + (placesData.selectedVisitOptions.visited ? 1 : 0) + (placesData.selectedVisitOptions.nonVisited ? 1 : 0) + (placesData.selectedFilterDistance == null ? 0 : 1)} 
                    onFilterButtonClick={onFilterButtonClick} 
                    onSortButtonClick={onSortButtonClick}
                    onSearchButtonClick={onSearchButtonClick}
                    isSearchInputOn={placesData.selectedSearchInput && placesData.selectedSearchInput.length > 0}
                    />
                  </div>
              } */}
              {
                placesData.places.filterPlacesByName(placesData.selectedSearchInput).map((place, index) => {
                    return <div>
                    <CurationListItem 
                    topLeftBadge={index + 1}
                    clickEvent={(_) => {
                       handleItemClick(place.id, place)
                    }} 
                    placeItem={place} 
                    key={place.key}
                    hoverInEvent={() => {
                      setCurationHoverId(place.id)
                    }}
                    hoverOutEvent={() => {
                      setCurationHoverId(null)
                    }}
                    mapEmoji={curationData.curation.emoji}
                    />
                    </div>
                })
              }
              {!isListLoading && curationData.curation.title && placesData.places.length == 0 &&
                <div className='w-full flex flex-col items-center mt-8 min-h-[80vh]'>
                  <svg className="w-16 h-16 fill-base-content" version="1.1" viewBox="0 0 310.883 310.883">
                    <path d="M299.459,174.267c0,0-16.433-71.773-16.707-72.356c-3.429-10.694-17.078-19.279-40.725-25.565
                        c-23.243-6.181-53.993-9.584-86.586-9.584c-32.592,0-63.343,3.403-86.586,9.584c-23.657,6.29-37.308,14.879-40.729,25.58
                        c-0.272,0.578-16.702,72.342-16.702,72.342C4.778,176.576,0,182.879,0,190.312c0,18.79,17.893,33.075,53.18,42.458
                        c27.533,7.32,63.85,11.353,102.261,11.353c0.002,0,0.004,0,0.006,0c38.41,0,74.724-4.031,102.255-11.352
                        c35.287-9.383,53.18-23.668,53.18-42.459C310.883,182.879,306.105,176.576,299.459,174.267z M211.452,189.198
                        c0,7.987-6.498,14.486-14.485,14.486c-7.755,0-14.107-6.124-14.471-13.79h-54.11c-0.365,7.666-6.715,13.79-14.469,13.79
                        c-7.988,0-14.486-6.499-14.486-14.486c0-3.783,1.458-7.232,3.842-9.815c-2.384-2.583-3.842-6.032-3.842-9.815
                        c0-7.987,6.499-14.486,14.486-14.486c7.754,0,14.104,6.124,14.469,13.79h54.11c0.364-7.666,6.716-13.79,14.471-13.79
                        c7.987,0,14.485,6.499,14.485,14.486c0,3.783-1.458,7.232-3.842,9.815C209.994,181.966,211.452,185.415,211.452,189.198z
                        M235.357,120c-21.545,5.448-49.926,8.449-79.916,8.449c-29.99,0-58.371-3.001-79.916-8.449
                        c-20.722-5.24-28.012-10.998-29.796-13.382c1.8-2.425,9.104-8.177,29.8-13.409c21.544-5.448,49.924-8.448,79.912-8.448
                        c29.987,0,58.367,3,79.911,8.448c20.654,5.223,27.97,10.961,29.789,13.395C263.329,109.033,256.023,114.773,235.357,120z"/>
                    </svg>
                  <div className='font-normal text-base-content mt-2'>Nothing here yet.</div>
                </div>
              }
              {isListLoading &&
              <div className='w-full flex flex-col items-center col-span-2 py-8 min-h-[100vh]'>
                <div className="loading loading-infinity loading-lg"></div>
                <div className='font-normal text-base-content mt-2'>Loading ...</div>
              </div>
              }
              {
                !isListLoading && !curationData.curation.title && <div className='w-full flex flex-col items-center col-span-2 py-8 min-h-[100vh]'>
                </div>
              }
              <div className='col-span-2'>
                <CoorayFooter />
              </div>
          </div>
          {
            <div className={`col-span-2 md:col-span-1 h-full max-h-screen relative order-1 md:order-last bg-base-300 pt-16 md:pt-0 max-w-full overflow-x-hidden`}>
              { (!isShowingList || isDesktopView) && placesData.places.length > 0 && <div className='relative w-full h-full'>
                  {/* {
                      curationData.curation.title && <div className={`z-20 md:hidden relative`}>
                        <CurationListFilterBar activeFilterSize={placesData.selectedFilterOptions.length + (placesData.selectedVisitOptions.visited ? 0 : 1) + (placesData.selectedVisitOptions.nonVisited ? 0 : 1) + (placesData.selectedFilterDistance == null ? 0 : 1)} onFilterButtonClick={onFilterButtonClick} onSortButtonClick={onSortButtonClick}/>
                      </div>
                  } */}
                  <RouteMap
                    isDesktop={true} 
                    ref={mapRef}
                    mapId={curationData.curation.id}
                    mapMarkerEmoji={curationData.curation.emoji != null ? curationData.curation.emoji : "📍"}
                    handlePopupItemClick={handlePopupItemClick}
                    handlePopupItemNavigateClick={handlePopupItemNavigateClick}
                    onToggleBackToListClick={() => { onToggleToListClick() }}
                    analytics={analytics}
                    onFilterButtonClick={onFilterButtonClick}
                  />

              </div>
              }

            {isListLoading && !isShowingList && 
              <div className='w-full flex flex-col items-center justify-center col-span-2 py-8'>
                <div className="loading loading-infinity loading-lg"></div>
                <div className='font-normal text-base-content mt-2'>Loading ...</div>
              </div>
              }
            </div>
          }
        </div>

        <SearchModal 
          existingSearchQuery={placesData.selectedSearchInput}
          isSearchBottomSheetOpen={isSearchBottomSheetOpen}
          onSearchApplyClick={(query)  => {
            // onApplySortTypeClick(type)
            onApplySearchClick(query)
          } }
          onSearchClearClick={() => {
            onApplySearchClick("")
          }}
          onSearchModalDismiss={() => {
            setIsSearchBottomSheetOpen(false)
          }}
        />

        <GeneratedInvitationLinkModal 
          isInvitationLinkModalOpen={generatedInvitationLink != null}
          url={generatedInvitationLink}
          onGeneratedInvitationLinkDismiss={() => {
            setGeneratedInvitationLink(null)
          }}
          onShareLinkClick={() => {
              shareContent(generatedInvitationTitle, generatedInvitationLink)
          }}
          onCopyLinkClick={() => {
              copyToClipboard(generatedInvitationLink)
          }}
        />

        {fullScreenLoadingText &&
          <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/70 z-50'>
              <div className="loading loading-infinity loading-lg"></div>
              <div className='font-normal text-base-content mt-2'>{ fullScreenLoadingText }</div>
          </div>}
      </div>
      {/* {
          curationData.curation.title && currentPage == 0 && (isShowingList) && <div className='max-w-1/2 fixed bottom-4 left-4 bg-transparent text-right md:hidden' ref={searchButtonRef}>
          <button className="btn md:btn-lg btn-circle text-base btn-secondary normal-case rounded-full" onClick={() => { onSearchButtonClick() }}>
          <svg className='w-5 h-5 stroke-secondary-content' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6725 16.6412L21 21M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          </button>
          </div>
        } */}
        {
          curationData.curation.title && currentPage == 0 && (isShowingList) && <div className='max-w-1/2 fixed bottom-4 right-4 bg-transparent text-right md:hidden' ref={mapButtonRef}>
          <button className="btn md:btn-lg text-base btn-primary normal-case rounded-full" onClick={() => { onToggleToMapClick() }}>
          <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path className="stroke-primary-content" d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg> Map
          </button>
          </div>
        }
        {
                <div className="fixed bottom-4 left-4 md:left-8">
                  {/* <button className={`group btn btn-sm md:btn-md normal-case font-bold ml-4 text-sm md:text-base rounded-full btn-neutral`} onClick={() => { setIsExplorePlaceFilterModelOpen(true) }}>
                      🎛️ Filters { selectedTags.length > 0 ? <div className="badge badge-secondary text-sm md:text-base">1</div> : <div></div> }
                  </button> */}
                  {/* {
                      curationData.curation.isSortAllowed && <button className="btn btn-circle btn-secondary shadow-xl" onClick={() => { onSortButtonClick() }}>
                        <div className="indicator">
                          <svg className='w-5 h-5' viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path className='stroke-secondary-content' d="M16 18L16 6M16 6L20 10.125M16 6L12 10.125" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                              <path className='stroke-secondary-content' d="M8 6L8 18M8 18L12 13.875M8 18L4 13.875" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                          {
                            placesData.selectedSortType != "recommended" && <span className="indicator-item badge badge-warning">1</span>
                          }
                        </div>
                    </button>
                  } */}

                  { <button className="btn text-base btn-secondary normal-case rounded-full" onClick={() => { onViewAllClick() }}>
                  <svg className='fill-secondary-content w-4 h-4' viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M2,12a2,2,0,1,1,2,2A2,2,0,0,1,2,12Zm10,2a2,2,0,1,0-2-2A2,2,0,0,0,12,14Zm8-4a2,2,0,1,0,2,2A2,2,0,0,0,20,10Z"/></svg> View All
                  </button>
                  }
      
                  {/* <button className="btn btn-circle btn-secondary shadow-xl rounded-l-none" onClick={() => { onFilterButtonClick() }}>
                      <svg className="w-5 h-5 stroke-secondary-content" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M19 3H5C3.58579 3 2.87868 3 2.43934 3.4122C2 3.8244 2 4.48782 2 5.81466V6.50448C2 7.54232 2 8.06124 2.2596 8.49142C2.5192 8.9216 2.99347 9.18858 3.94202 9.72255L6.85504 11.3624C7.49146 11.7206 7.80967 11.8998 8.03751 12.0976C8.51199 12.5095 8.80408 12.9935 8.93644 13.5872C9 13.8722 9 14.2058 9 14.8729L9 17.5424C9 18.452 9 18.9067 9.25192 19.2613C9.50385 19.6158 9.95128 19.7907 10.8462 20.1406C12.7248 20.875 13.6641 21.2422 14.3321 20.8244C15 20.4066 15 19.4519 15 17.5424V14.8729C15 14.2058 15 13.8722 15.0636 13.5872C15.1959 12.9935 15.488 12.5095 15.9625 12.0976C16.1903 11.8998 16.5085 11.7206 17.145 11.3624L20.058 9.72255C21.0065 9.18858 21.4808 8.9216 21.7404 8.49142C22 8.06124 22 7.54232 22 6.50448V5.81466C22 4.48782 22 3.8244 21.5607 3.4122C21.1213 3 20.4142 3 19 3Z" strokeWidth="1.5"/>
                      </svg>
                              
                  </button> */}
                </div>
        }
        <div ref={desktopIndicatorRef} className='md:hidden'>
        </div>

        {isWebsitePaused && <div className='w-full h-full fixed top-0 flex flex-col items-center justify-center z-50 bg-base-300'>
              <div className='text-lg font-normal text-base-content bg-base-300 flex-1 w-full flex flex-col items-center justify-center px-4'>🚧 This map is under construction ...</div>
          </div>}

        {
              toastMessage && <div className="toast z-10">
              <div className={`alert ${toastMessage.type == "success" ? "alert-success" : "alert-info"}`}>
              <span className="text-sm">{toastMessage.message}</span>
              </div>
          </div>
          }
    </div>
    )
  }